import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../css/Form.css';

const AddProduct = () => {
  const [formData, setFormData] = useState({
    name: '',
    color: '',
    size: '',
    description: '',
    price: '',
    discount: '',
    stock: '',
    categories: [] // Array to hold selected categories
  });

  const [categories, setCategories] = useState([]); // Categories fetched from API
  const [images, setImages] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const token = localStorage.getItem('token'); // JWT Token for Auth

  // Fetch categories from API
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/product/allCategory`, {
        //headers: { Authorization: `Bearer ${token}` }, // Add token if needed
      })
      .then((response) => {
        setCategories(response.data); // Assuming response contains an array of category names
      })
      .catch((error) => {
        console.error('Failed to fetch categories:', error);
        setErrorMessage('Failed to load categories.');
      });
  }, [token]);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle category checkbox change
  const handleCategoryChange = (category) => {
    const updatedCategories = formData.categories.includes(category)
      ? formData.categories.filter((cat) => cat !== category) // Remove category if already selected
      : [...formData.categories, category]; // Add category if not selected

    setFormData({ ...formData, categories: updatedCategories });
  };

  // Handle image upload (limit 1-5 images)
  const handleImageChange = (e) => {
    const selectedImages = Array.from(e.target.files);

    if (selectedImages.length > 5) {
      setErrorMessage('You can upload a maximum of 5 images.');
    } else if (selectedImages.length < 1) {
      setErrorMessage('Please upload at least 1 image.');
    } else {
      setImages(selectedImages);
      setErrorMessage('');
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (images.length < 1 || images.length > 5) {
      setErrorMessage('Please upload between 1 and 5 images.');
      return;
    }

    const data = new FormData();

    // Append product details
    Object.entries(formData).forEach(([key, value]) => {
      if (key === 'categories') {
        value.forEach((category) => data.append('category', category));
      } else {
        data.append(key, value);
      }
    });

    // Append images
    images.forEach((image) => {
      data.append('images', image);
    });

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/product/add`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
          // 'Authorization': `Bearer ${token}` // Include JWT token if needed for authorization
        },
      });

      setSuccessMessage('Product added successfully!');
      setFormData({
        name: '',
        color: '',
        size: '',
        description: '',
        price: '',
        discount: '',
        stock: '',
        categories: [],
      });
      setImages([]);
    } catch (error) {
      console.error('Error adding product:', error);
      setErrorMessage('Failed to add product. Please try again.');
    }
  };

  return (
    <div className="form-container">
      <div className="form-wrapper">
        <h2>Add New Product</h2>

        {errorMessage && <div className="error-message">{errorMessage}</div>}
        {successMessage && <div className="success-message">{successMessage}</div>}

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Product Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="color"
            placeholder="Color"
            value={formData.color}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="size"
            placeholder="Size"
            value={formData.size}
            onChange={handleChange}
            required
          />
          <textarea
            name="description"
            placeholder="Description"
            value={formData.description}
            onChange={handleChange}
            required
          />
          <input
            type="number"
            name="price"
            placeholder="Price"
            value={formData.price}
            onChange={handleChange}
            required
          />
          <input
            type="number"
            name="discount"
            placeholder="Discount"
            value={formData.discount}
            onChange={handleChange}
            required
          />
          <input
            type="number"
            name="stock"
            placeholder="Stock"
            value={formData.stock}
            onChange={handleChange}
            required
          />

          {/* Categories Checkbox */}
          <div className="category-checkbox">
            <strong>Select Categories:</strong>
            {categories.map((category, index) => (
              <label key={index}>
                <input
                  type="checkbox"
                  value={category}
                  checked={formData.categories.includes(category)}
                  onChange={() => handleCategoryChange(category)}
                />
                {category}
              </label>
            ))}
          </div>

          {/* Image Upload */}
          <input
            type="file"
            multiple
            accept="image/*"
            onChange={handleImageChange}
            required
          />
          <p>Upload 1 to 5 images</p>

          <button type="submit">Add Product</button>
        </form>
      </div>
    </div>
  );
};

export default AddProduct;
